import { OfferDayChips } from 'components/mobile/OfferDayChips/OfferDayChips';
import { offerWindow } from 'helpers/offerWindow';
import { MobileLayout } from 'components/mobile/MobileLayout/MobileLayout';
import styles from '../styles/pages/SportsBetting.module.css';
import { SportList } from 'components/SportList/SportList';
import { useBreakpoint } from 'hooks/useBreakpoint';
import { Layout } from 'components/Layout/Layout';
import { SportsBetting as SportsBettingComponent } from 'components/SportsBetting/SportsBetting';
import { useContext, useMemo, useState } from 'react';
import useAsyncEffect from 'use-async-effect';
import { PrematchCatalogContext } from 'context/prematchCatalogContext';
import { getLeagues, getSports } from 'services/api/sportBetsService';
import { Loader } from 'components/Loader/Loader';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { usePlayerLayout } from 'lib/playerLayout';
import { leagueOfferPath } from 'components/mobile/ModernSportNav/ModernSportNav';
import type { League } from 'types/League';
import type { Sport } from 'types/Sport';

export const SportsBetting = () => {
  const { isMobile } = useBreakpoint();
  const { lastPrematchPush } = useContext(PrematchCatalogContext);
  const prematchCatalogBump = lastPrematchPush?.version ?? 0;
  const [allSports, setAllSports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  // Modern mobile opens straight on the top league of the first sport; the
  // sport and league rails there lead everywhere else.
  const modernMobile = usePlayerLayout() === 'modern' && isMobile;

  const time = searchParams.get('time');
  // ?time= is an offer window key (helpers/offerWindow).
  const offer = useMemo(() => offerWindow(time), [time]);
  const dateTime = offer.to;

  useAsyncEffect(async () => {
    try {
      const gamesResponse = await getSports(dateTime, { fromTime: offer.from });
      const first: Sport | undefined = gamesResponse?.[0];
      if (modernMobile && first) {
        const leagues: League[] | null = await getLeagues(first.id, dateTime);
        if (leagues?.length) {
          const q = time ? `?time=${time}` : '';
          navigate(leagueOfferPath(first, leagues[0]) + q, { replace: true });
          return;
        }
      }
      setIsLoading(false);
      setAllSports(gamesResponse);
    } catch {
      setIsLoading(false);
    }
  }, [dateTime, offer.from, prematchCatalogBump, modernMobile]);
  return (
    <>
      {isMobile ? (
        <MobileLayout topContent={<OfferDayChips />}>
          <div className={styles.wrapper}>
            {isLoading ? (
              <Loader />
            ) : (
              <SportList sports={allSports} time={time} />
            )}
          </div>
        </MobileLayout>
      ) : (
        <Layout whiteBg>
          <SportsBettingComponent hideImageSlider />
        </Layout>
      )}
    </>
  );
};
